import { render, staticRenderFns } from "./Box2.vue?vue&type=template&id=4eb0e4f6&scoped=true&"
import script from "./Box2.vue?vue&type=script&lang=js&"
export * from "./Box2.vue?vue&type=script&lang=js&"
import style0 from "./Box2.vue?vue&type=style&index=0&id=4eb0e4f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../src/h5-coursePage/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4eb0e4f6",
  null
  
)

export default component.exports